import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Feel Free To Discuss Your Project</h2>
            </div>
            <p>
              We're excited to connect with you! Whether you're seeking to
              transform your online visibility, revolutionize your brand's
              impact, or venture into new digital horizons. We're here to turn
              your aspirations into reality. Let's collaborate and craft a
              compelling digital journey that sets your brand apart in the
              ever-evolving digital sphere.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
